(function( $ ) {
  // Set default consent configuration to 'denied'
  function setDefaultConsentConfig() {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('consent', 'default', {
        ad_storage: 'denied',
        analytics_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        functionality_storage: true,
      });
    }
  }

  function sendMarketingConsent(readFromCookies) {
    console.log('sendMarketingConsent called', { readFromCookies });
    
    let consentMarketingStorage, consentAnalyticsStorage;

    if (readFromCookies) {
      consentMarketingStorage = getCookieValue('cmplz_marketing') === 'allow';
      consentAnalyticsStorage = getCookieValue('cmplz_statistics') === 'allow';
      console.log('Reading consent from cookies', { consentMarketingStorage, consentAnalyticsStorage });
    } else {
      consentMarketingStorage = $('#cmplz-marketing-optin').is(':checked');
      consentAnalyticsStorage = $('#cmplz-statistics-optin').is(':checked');
      console.log('Reading consent from checkboxes', { consentMarketingStorage, consentAnalyticsStorage });
    }

    const consentData = {
      analytics_storage: consentAnalyticsStorage,
      marketing_storage: consentMarketingStorage,
      ad_user_data: consentMarketingStorage,
      ad_storage: consentMarketingStorage,
      ad_personalization: consentMarketingStorage,      
      functionality_storage: true,
    };

    // Push consent data to dataLayer
    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push({
        'event': 'marketingConsent',
        'consentData': consentData
      });
    } else {
      console.log('dataLayer not defined, retrying in moment');
      setTimeout(() => sendMarketingConsent(readFromCookies), 300);
    }

    // Update consent configuration for Google tags
    if (typeof window.gtag !== 'undefined') {
      window.gtag('consent', 'update', {
        ad_storage: consentMarketingStorage ? 'granted' : 'denied',
        analytics_storage: consentAnalyticsStorage ? 'granted' : 'denied',
        marketing_storage: consentMarketingStorage ? 'granted' : 'denied',
        ad_user_data: consentMarketingStorage ? 'granted' : 'denied',
        ad_personalization: consentMarketingStorage ? 'granted' : 'denied',
      });
    }
  }

  function getCookieValue(name) {
    const nameString = name + "=";
    const value = document.cookie.split(';').find(item => item.trim().startsWith(nameString));
    return value ? decodeURIComponent(value.split('=')[1]) : null;
  }

  $('body').on('click', '.cmplz-accept', function(){
    $('#cmplz-marketing-optin').prop('checked', true);
    $('#cmplz-statistics-optin').prop('checked', true);
    sendMarketingConsent(false);
  });

  $('body').on('click', '#cmplz-cookiebanner-container button:not(".cmplz-view-preferences")', function(){
    console.log('Consent button clicked');
    sendMarketingConsent(false);
  });

  //setDefaultConsentConfig();
  sendMarketingConsent(true);
})(jQuery);



// WEBPACK FOOTER //
// ./resources/js/partials/google_content.js